<script setup>

import {
  LanguageIcon,
  LockClosedIcon,
  ShieldCheckIcon,
  StarIcon,
  UserIcon,
} from '@heroicons/vue/24/outline';
import IncentiveCard from '@/components/landing/IncentiveCard.vue';
import InboxCustomizeIcon from '@/components/CustomIcons/InboxCustomizeIcon.vue';
</script>

<template>

  <div class="bg-primary text-basecolor py-8 md:py-24 px-6">
    <div class="mx-auto max-w-7xl">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-3xl">
          <h2 class="text-3xl font-semibold tracking-tight">
            {{ $t('landingPage.whySection.title') }}
          </h2>
        </div>
        <div class="mt-16 grid xl:grid-cols-2 grid-cols-1 gap-x-20 gap-y-10">
          <div>
            <h3 class="text-lg font-semibold tracking-tight">
              {{ $t('landingPage.whySection.block1.title') }}
            </h3>
            <p class="text-sm mt-4">
              {{ $t('landingPage.whySection.block1.text') }}
            </p>
          </div>
          <div>
            <h3 class="text-lg font-semibold tracking-tight">
              {{ $t('landingPage.whySection.block2.title') }}
            </h3>
            <div class="mt-4 text-sm">
              <ul class="list-disc list-inside">
                <li>{{ $t('landingPage.whySection.block2.bullet1') }}</li>
                <li>{{ $t('landingPage.whySection.block2.bullet2') }}</li>
                <li>{{ $t('landingPage.whySection.block2.bullet3') }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mx-auto max-w-7xl sm:pt-24 pt-10">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-3xl">
          <h2 class="text-2xl font-bold tracking-tight">
            {{ $t('landingPage.whySection.incentivesTitle') }}
          </h2>
        </div>
        <div class="mt-16 grid grid-cols-1 gap-x-16 gap-y-10 lg:grid-cols-3">
          <IncentiveCard
            :icon="StarIcon"
            :title="$t('landingPage.whySection.incentives[0].title')"
            :desc="$t('landingPage.whySection.incentives[0].text')"
          />
          <IncentiveCard
            :icon="UserIcon"
            :title="$t('landingPage.whySection.incentives[1].title')"
            :desc="$t('landingPage.whySection.incentives[1].text')"
          />
          <IncentiveCard
            :icon="ShieldCheckIcon"
            :title="$t('landingPage.whySection.incentives[2].title')"
            :desc="$t('landingPage.whySection.incentives[2].text')"
          />
          <IncentiveCard
            :icon="LanguageIcon"
            :title="$t('landingPage.whySection.incentives[3].title')"
            :desc="$t('landingPage.whySection.incentives[3].text')"
          />
          <IncentiveCard
            :icon="InboxCustomizeIcon"
            :title="$t('landingPage.whySection.incentives[4].title')"
            :desc="$t('landingPage.whySection.incentives[4].text')"
          />
          <IncentiveCard
            :icon="LockClosedIcon"
            :title="$t('landingPage.whySection.incentives[5].title')"
            :desc="$t('landingPage.whySection.incentives[5].text')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
